﻿import $ from "jquery";
import tinymce from 'tinymce';
import bootbox from 'bootbox';
import { Modal, Carousel } from "bootstrap";

// UI + theme (TinyMCE 6/7)
import 'tinymce/icons/default';
import 'tinymce/themes/silver';

// Model (pri niektorých bundloch treba)
import 'tinymce/models/dom';

$(() => {
    $("#loading-spinner").addClass("spinner-border text-primary");

    let lastRequest: JQuery.jqXHR<any> | null = null;

    $('#materialDetailModal')
        .off('show.bs.modal.zuba')
        .on('show.bs.modal.zuba', function (event: any) {
            const $trigger = $(event.relatedTarget).closest('[data-bs-toggle="modal"]');

            console.log("show.bs.modal fired, relatedTarget:", event.relatedTarget);

            const title =
                $trigger.attr('data-bs-title')                  // CTA používa data-bs-title
                || String($trigger.data('title') ?? '');        // materiály používajú data-title

            const url = String($trigger.data('url') ?? '');

            // 1) reset obsahu hneď, aby tam nikdy nezostal starý material
            $("#materialDetailDiv").html("");
            $("#materialDetailDiv").addClass("is-loading"); // voliteľné (ak máš CSS)

            // ak máš title element
            $('#materialDetailTitle').text(title);

            // 2) abort predchádzajúci request (race condition fix)
            if (lastRequest) lastRequest.abort();

            lastRequest = $.ajax({
                type: 'GET',
                url: url,
                dataType: 'json', // ✅ lebo Info vracia Json { html: ... }
                beforeSend: function () {
                    $('#spinnerContainer').removeClass('d-none');
                },
                complete: function () {
                    $('#spinnerContainer').addClass('d-none');
                    $("#materialDetailDiv").removeClass("is-loading");
                }
            });

            lastRequest.done(function (res: any) {
                // bezpečne
                const html = res?.html ?? "";
                $("#materialDetailDiv").html(html);
            });

            lastRequest.fail(function (jqXHR) {
                if (jqXHR.statusText === "abort") return;
                console.error(jqXHR);
                $("#materialDetailDiv").html("<div class='p-3'>Nepodarilo sa načítať obsah.</div>");
            });
        });

    $('#materialDetailModal').on('hidden.bs.modal', function () {
        $("#materialDetailDiv").html("");
    });

    $('#headlineDetailModal')
        .off('show.bs.modal.zuba')
        .on('show.bs.modal.zuba', function (event: any) {
            const $trigger = $(event.relatedTarget).closest('[data-bs-toggle="modal"]');

            console.log("show.bs.modal fired, relatedTarget:", event.relatedTarget);

            const title =
                $trigger.attr('data-bs-title')                  // CTA používa data-bs-title
                || String($trigger.data('title') ?? '');        // materiály používajú data-title

            const url = String($trigger.data('url') ?? '');

            // 1) reset obsahu hneď, aby tam nikdy nezostal starý material
            $("#headlineDetailDiv").html("");
            $("#headlineDetailDiv").addClass("is-loading"); // voliteľné (ak máš CSS)

            // 2) abort predchádzajúci request (race condition fix)
            if (lastRequest) lastRequest.abort();

            lastRequest = $.ajax({
                type: 'GET',
                url: url,
                dataType: 'json', // ✅ lebo Info vracia Json { html: ... }
                beforeSend: function () {
                    $('#spinnerContainer').removeClass('d-none');
                },
                complete: function () {
                    $('#spinnerContainer').addClass('d-none');
                    $("#headlineDetailDiv").removeClass("is-loading");
                }
            });

            lastRequest.done(function (res: any) {
                // bezpečne
                const html = res?.html ?? "";
                $("#headlineDetailDiv").html(html);
            });

            lastRequest.fail(function (jqXHR) {
                if (jqXHR.statusText === "abort") return;
                console.error(jqXHR);
                $("#headlineDetailDiv").html("<div class='p-3'>Nepodarilo sa načítať obsah.</div>");
            });
        });

    $('#headlineDetailModal').on('hidden.bs.modal', function () {
        $("#headlineDetailDiv").html("");
    });

    // =========================
    // PRODUCTS POPUP (Home top 6)
    // =========================
    initProductsPopup();
});

// =========================
// Products popup init
// =========================
function initProductsPopup(): void {
    const $modal = $("#productPopup");
    if ($modal.length === 0) return; // Home nemusí mať modal markup

    const modal = Modal.getOrCreateInstance($modal[0], {
        backdrop: true,
        keyboard: true,
        focus: true
    });

    const $inner = $("#productPopupInner");
    const $dots = $("#productPopupDots");
    const $title = $("#productPopupTitle");

    const carouselEl = document.getElementById("productPopupCarousel") as HTMLElement | null;
    if (!carouselEl) return;

    const carousel = Carousel.getOrCreateInstance(carouselEl, {
        interval: false,
        ride: false,
        wrap: true,
        touch: true
    });

    function render(images: string[]) {
        $inner.empty();
        $dots.empty();

        images.forEach((url, i) => {
            const active = i === 0 ? "active" : "";
            $inner.append(`
                <div class="carousel-item ${active}">
                    <img class="zuba-product-modal-img" src="${url}" alt="">
                </div>
            `);

            $dots.append(`
                <button type="button"
                        class="${i === 0 ? "is-active" : ""}"
                        data-dot="${i}"
                        aria-label="Slide ${i + 1}">
                </button>
            `);
        });

        carousel.to(0);
        setActiveDot(0);
    }

    function setActiveDot(index: number) {
        $dots.find("button").removeClass("is-active");
        $dots.find(`button[data-dot="${index}"]`).addClass("is-active");
    }

    // Open popup (Home top produkty musia mať .js-product-popup + data-popup-images)
    $(document).on("click", ".js-product-popup", function (e) {
        e.preventDefault();

        const title = String($(this).data("popup-title") ?? "");
        $title.text(title);

        const raw = $(this).attr("data-popup-images") ?? "[]";
        let images: string[] = [];
        try { images = JSON.parse(raw); } catch { images = []; }

        if (!images || images.length === 0) return;

        render(images);
        modal.show();
    });

    // Dots click
    $(document).on("click", "#productPopupDots button", function () {
        const i = parseInt(String($(this).data("dot")), 10);
        if (!isNaN(i)) carousel.to(i);
    });

    // Update dots on slide
    $(carouselEl).on("slid.bs.carousel", () => {
        const idx = $(carouselEl).find(".carousel-item.active").index();
        setActiveDot(idx);
    });

    // Desktop drag (pointer)
    let startX: number | null = null;
    let dragging = false;

    $(document).on("pointerdown", "#productPopupCarousel", function (ev) {
        startX = (ev as any).originalEvent?.clientX ?? null;
        dragging = true;
    });

    $(document).on("pointerup pointercancel", "#productPopupCarousel", () => {
        startX = null;
        dragging = false;
    });

    $(document).on("pointermove", "#productPopupCarousel", function (ev) {
        if (!dragging || startX === null) return;

        const x = (ev as any).originalEvent?.clientX ?? startX;
        const dx = x - startX;

        if (Math.abs(dx) > 60) {
            dx < 0 ? carousel.next() : carousel.prev();
            startX = null;
            dragging = false;
        }
    });

    // Reset pri zavretí
    $modal.on("hidden.bs.modal", () => {
        $inner.empty();
        $dots.empty();
        $title.text("");
    });
}

export function showMessage(message: string, title: string = "") {
    if (title.length == 0)
        title = "ZUBA";

    bootbox.alert({
        title: title,
        message: message,
        className: "zuba-bootbox",
        backdrop: true,
        centerVertical: true
    })
}

export function initTinymce(textAreaId: string, minHight: number, bodyClass: string = '', contentCss: string = '') {

    if (contentCss === '') contentCss = '/css/editor-content.css';

    const existing = tinymce.EditorManager.get(textAreaId);
    if (existing) return;

    const mergedBodyClass = ['zuba-richtext', bodyClass].filter(Boolean).join(' ');
    tinymce.init({
        selector: '#' + textAreaId,
        license_key: 'gpl',
        resize: 'both',
        min_height: minHight,

        plugins: 'advlist lists link image table code',

        toolbar:
            'styles | undo redo | ' +
            'bold italic | alignleft aligncenter alignright | ' +
            'bullist numlist outdent indent | link image | table | code',

        menubar: true, // môžeš dať true na test

        body_class: mergedBodyClass,
        content_css: contentCss,

        /* enable title field in the Image dialog*/
        image_title: true,
        images_upload_url: '/editor/upload',
        images_upload_credentials: true, // ak používaš cookies/auth
        /* enable automatic uploads of images represented by blob or data URIs*/
        automatic_uploads: true,
        file_picker_types: 'image',

        convert_urls: false,
        relative_urls: false,
        remove_script_host: false,

        image_class_list: [
            { title: 'Default', value: '' },
            { title: 'Left (wrap text)', value: 'zuba-rt-img-left' },
            { title: 'Right (wrap text)', value: 'zuba-rt-img-right' },
            { title: 'Center', value: 'zuba-rt-img-center' },
            { title: 'Full width', value: 'zuba-rt-img-full' }
        ],

        // --- Styles dropdown ---
        style_formats: [
            {
                title: 'Normal text',
                block: 'p',
                classes: 'zuba-rt-text'
            },
            {
                title: 'Lead / Perex',
                block: 'p',
                classes: 'zuba-rt-lead'
            },
            {
                title: 'Title (Organetto)',
                block: 'p',
                classes: 'zuba-rt-title'
            },
            {
                title: 'Section title',
                block: 'p',
                classes: 'zuba-rt-h2'
            },
            {
                title: 'Kicker (uppercase)',
                block: 'p',
                classes: 'zuba-rt-kicker'
            },
            {
                title: 'Small label',
                block: 'p',
                classes: 'zuba-rt-label'
            },
            {
                title: 'Note / Info box',
                block: 'p',
                classes: 'zuba-rt-note'
            },
            {
                title: 'Small text',
                block: 'p',
                classes: 'zuba-rt-small'
            },
            {
                title: 'Muted text',
                block: 'p',
                classes: 'zuba-rt-muted'
            }
        ],



        // --- Paste: nech neťahá štýly z Wordu ---
        paste_as_text: true,

        // Default look inside editor
        content_style:
            'body { font-family: Helvetica, Arial, sans-serif; font-size:16px; }' +
            'img { max-width:100%; height:auto; }'
    });

}